import * as React from 'react';

/** Semantic status — current state of a device, job, or object. */
export type StatusTone = 'success' | 'danger' | 'warning' | 'info' | 'pending' | 'unknown';

/** @deprecated Prefer `status`. Kept so existing call sites keep compiling. */
export type StatusColor = 'green' | 'blue' | 'red' | 'orange' | 'grey';

export interface StatusLabelProps {
  /** PatternFly status. Prefer this over `color`. */
  status?: StatusTone;
  /** Legacy color map. `orange` is warning only — never use it for pending. */
  color?: StatusColor;
  children: React.ReactNode;
  className?: string;
  /** Pulse the status dot for in-progress work (building, pushing, syncing). */
  pulse?: boolean;
  /** @deprecated Status uses a dot indicator; icons are not rendered */
  icon?: React.ReactNode;
}

const COLOR_TO_TONE: Record<StatusColor, StatusTone> = {
  green: 'success',
  red: 'danger',
  orange: 'warning',
  blue: 'info',
  grey: 'pending',
};

const StatusLabel: React.FunctionComponent<StatusLabelProps> = ({
  status,
  color = 'grey',
  className = '',
  children,
  pulse = false,
}) => {
  const tone = status ?? COLOR_TO_TONE[color];

  return (
    <span
      className={['app-status-label', `app-status-label--${tone}`, pulse ? 'app-status-label--pulse' : '', className]
        .filter(Boolean)
        .join(' ')}
    >
      <span className="app-status-label__dot" aria-hidden="true" />
      <span className="app-status-label__text">{children}</span>
    </span>
  );
};

export { StatusLabel };
